import { COLOURS } from "../constants";

export const fillColorUtils = (isActive, colour, fill = COLOURS.black) => {
    const color = colour ? colour : fill;
    return isActive !== undefined && isActive !== "" && !isActive
        ? COLOURS.grey
        : color;
};
